const { gql } = require('graphql-tag');

const StoreQueryResultFragment = require('../fragments/stores/storeQueryResultFragment').fragment;
const { CUSTOM_QUERIES } = require('#~/constants/customQueries.js');

module.exports = {
  [CUSTOM_QUERIES.STORES.stores]: (params) => {
    const variables = params.variables;
    return {
      query: gql`
        ${StoreQueryResultFragment}

        query stores(
          $where: String
          $sort: [String!]
          $limit: Int
          $offset: Int
          $locale: Locale!
        ) {
          stores(
            where: $where
            sort: $sort
            limit: $limit
            offset: $offset
          ) {
            ...StoreQueryResultFragment
          }
        }`,
      variables,
    };
  },
};
